/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://7wv4omaa0i.execute-api.us-east-1.amazonaws.com/tmobileprd",
            "region": "us-east-1"
        },
        {
            "name": "TMOAmplifyApi",
            "endpoint": "https://gvfkrb5qc2.execute-api.us-east-1.amazonaws.com/tmobileprd",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:fce8c7ea-91a3-4fce-8761-cdc923e395b4",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_5G5FC6Omc",
    "aws_user_pools_web_client_id": "4vhbitg67e2vvrfldruiahd44",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "tmo-content32220-tmobileprd",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
